export default {
  dataType: {
    DataIdentifier: 'Signal',
    MeaningIdentifier: 'Bedeutung',
  },
};
